module.exports = __webpack_public_path__ + "media/jestockemonbateau.729f168d.webm";